import React from "react";
// javascript library that creates a parrallax effect
import Rellax from "rellax";
// reactstrap components
import {
    Container,
    Row,
    Col,
    Card,
    CardBody
} from "reactstrap";

import PresentationHeader from "components/Headers/PresentationHeader2.js";

function Diagnostico() {

    React.useEffect(() => {
        document.body.classList.add("presentation-page");
        document.body.classList.add("sidebar-collapse");
        document.documentElement.classList.remove("nav-open");
        window.scrollTo(0, 0);
        document.body.scrollTop = 0;

        // initialise Rellax for this page
        if (window.innerWidth >= 991) {
            setTimeout(function () {
                new Rellax(".rellax", {
                    center: true,
                });
            }, 5000);
            new Rellax(".rellax-header");
            new Rellax(".rellax-text");
        }

        // we need to add a script for the github buttons
        let script = document.createElement("script");
        script.src = "https://buttons.github.io/buttons.js";
        script.id = "github-buttons-script-id";
        document.body.appendChild(script);

        return function cleanup() {
            document.body.classList.remove("tramites-page");
            document.body.classList.remove("sidebar-collapse");

            // we need to remove the script when we change the page
            script.parentNode.removeChild(script);
        };
    });
    return (
        <>
            <Container className="fluid">
                <PresentationHeader titulo="Diagnostico e identificación de problemas" />
                <Row className="justify-content-center">
                    <Col md="12">
                        <Card>
                            <CardBody>
                                <p className="text-justify" style={{ fontSize: "14px", color: "#68696F", fontFamily:"serif" }}>
                                    <b>La participación para el diagnóstico e identificación de problemas</b> es la vinculación de ciudadanos e interesados en
                                    el proceso de recolección y análisis de información para identificar y explicar los problemas que les afecta
                                    directa o indirectamente con base en datos, ideas, hechos, experiencias y propuestas relacionados con la
                                    caracterización de la situación abordada, lo que permite identificar las problemáticas y las necesidades de los
                                    grupos de valor de la entidad.*
                                    <br></br>
                                    <br></br>
                                    <a href="https://www.funcionpublica.gov.co/inicio?p_p_state=maximized&p_p_mode=view&saveLastPath=false&_com_liferay_login_web_portlet_LoginPortlet_mvcRenderCommandName=%2Flogin%2Flogin&p_p_id=com_liferay_login_web_portlet_LoginPortlet&p_p_lifecycle=0&_com_liferay_login_web_portlet_LoginPortlet_redirect=%2Fdocuments%2F">
                                        <b style={{ color: '#045FB4' }}>
                                            * Departamento Administrativo de la Función Pública (2021). Lineamientos para publicar información en el menú participa sobre participación ciudadana en la gestión pública. Obtenido de: https://www.funcionpublica.gov.co/documents/
                                        </b>
                                    </a>
                                </p>
                                <center>
                                    <br></br>
                                    <a type="button" href={"https://drive.google.com/file/d/1HOIqhmiILYZmXBHh4uWJYSOitrCG09z4/view?usp=sharing"} style={{ borderBottom: "none" }} target="_black">
                                        <img
                                            alt="Imagen con referencia hacia un icono para descargar un archivo en PDF"
                                            width="80px"
                                            src={require("assets/img/Notaria/PDF.png")}
                                        ></img>
                                        <h6 className="texto">Temas Interes</h6>
                                    </a>
                                    <br></br>
                                    <a type="button" href={"https://drive.google.com/file/d/1rBGI4aLb73MLWP0knR6D-PgPy5FkO8kC/view?usp=sharing"} style={{ borderBottom: "none" }} target="_black">
                                        <img
                                            alt="Imagen con referencia hacia un icono para descargar un archivo en PDF"
                                            width="80px"
                                            src={require("assets/img/Notaria/PDF.png")}
                                        ></img>
                                        <h6 className="texto">Diagnostico e Identificacion</h6>
                                    </a>
                                </center>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default Diagnostico;